import { useState} from 'react';
import { Grid, Card, CardContent, Chip, Stack, Typography } from '@mui/material';

// COMPONENTES
import MiTabla from '../../../components/plantilla/tabla/MiTabla';
import ModalUserEvents from './modales/ModalUserEvents';

// USE SERVICES
import { useUserStats } from '../../../useQuery/useDashboard';

// ICONOS
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents"; // trofeo 1°
import MilitaryTechIcon from "@mui/icons-material/MilitaryTech"; // medallas

const UsersDashboard = () => {

    const [filters, setFilters] = useState({
        user: null,
        userId: null,
        start: null,
        end: null
    });

    const { data, isLoading } = useUserStats(filters.start, filters.end);

    const columns = [

        { 
            field: 'user', 
            headerName: 'User',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'total_registros', 
            headerName: 'Total Events',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'avg_hrs_min', 
            headerName: 'Avg Response Time',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },

    ]

    // objetivo (ajústalo si quieres otra meta)
    const GOAL_SECONDS = 60 * 5; // 1 hora

    // ordena por tiempo promedio ascendente (más rápido primero)
    const sorted = Array.isArray(data)
    ? [...data].sort((a, b) => (a?.avg_segundos ?? Infinity) - (b?.avg_segundos ?? Infinity))
    : [];

    const top3 = sorted.slice(0, 3);
    const ranks = ["1st", "2nd", "3rd"];

    const handleRowClick = ( row ) => {

        console.log(row.row);

        setFilters({
            ...filters,
            userId: row.row.id,
            user: row.row.user,
        });

        //setSelectedUser(user);
        setShowModal(true);

    }

    const [showModal, setShowModal] = useState(false);

    if(isLoading){
        return <div>Loading...</div>
    }

    return (

        <Grid container spacing={2}>

            <Grid size={6}>

                <MiTabla
                    columns={columns}
                    data={data}
                    onRowClick={handleRowClick}
                />

            </Grid>

            <Grid size={6}>
                
                <Stack spacing={2}>

                    {/* Card 1: Goal */}
                    <Card
                        sx={(theme) => ({
                            borderRadius: 3,
                            border: "1px solid",
                            borderColor: "divider",
                            background:
                            theme.palette.mode === "light"
                                ? "linear-gradient(180deg, #fff, #fafafa)"
                                : "rgba(255,255,255,0.03)",
                            boxShadow: "0 1px 1px rgba(0,0,0,.04), 0 2px 6px rgba(0,0,0,.06)",
                        })}
                    >
                    <CardContent>
                        <Typography variant="overline" sx={{ letterSpacing: 0.6 }}>
                        Response time goal
                        </Typography>
                        <Stack direction="row" alignItems="center" spacing={1}>
                        <Typography variant="h5" sx={{ fontWeight: 800 }}>
                            ≤ {Math.floor(GOAL_SECONDS / 3600)}h {Math.floor((GOAL_SECONDS % 3600) / 60)}m
                        </Typography>
                        <Chip label="SLA" size="small" color="success" />
                        </Stack>
                        <Typography variant="body2" sx={{ opacity: 0.7, mt: 0.5 }}>
                        Promedio objetivo por evento
                        </Typography>
                    </CardContent>
                    </Card>

                    {/* Cards 2–4: Top 3 */}
                    {top3.map((u, idx) => {
                    const hitGoal = (u?.avg_segundos ?? Infinity) <= GOAL_SECONDS;
                    const medal =
                        idx === 0 ? <EmojiEventsIcon fontSize="small" /> : <MilitaryTechIcon fontSize="small" />;

                    return (
                        <Card
                        key={u?.attended_by ?? idx}
                        sx={(theme) => ({
                            borderRadius: 3,
                            border: "1px solid",
                            borderColor: "divider",
                            background:
                            theme.palette.mode === "light"
                                ? "linear-gradient(180deg, #fff, #fafafa)"
                                : "rgba(255,255,255,0.03)",
                            boxShadow: "0 1px 1px rgba(0,0,0,.04), 0 2px 6px rgba(0,0,0,.06)",
                        })}
                        >
                        <CardContent>
                            <Stack direction="row" alignItems="center" justifyContent="space-between">
                            <Stack direction="row" spacing={1} alignItems="center">
                                {medal}
                                <Typography variant="overline" sx={{ letterSpacing: 0.6 }}>
                                {ranks[idx]}
                                </Typography>
                            </Stack>

                            <Chip
                                size="small"
                                label={u?.avg_hrs_min ?? "—"}
                                color={hitGoal ? "success" : "default"}
                                variant={hitGoal ? "filled" : "outlined"}
                            />
                            </Stack>

                            <Typography variant="h6" sx={{ fontWeight: 800, mt: 0.5 }}>
                            {u?.user ?? "—"}
                            </Typography>

                            <Typography variant="body2" sx={{ opacity: 0.7 }}>
                            {u?.total_registros ?? 0} eventos
                            </Typography>
                        </CardContent>
                        </Card>
                    );
                    })}

                </Stack>

            </Grid>

            {/* MODAL USER EVENTS */}

            <ModalUserEvents
                open={showModal}
                onClose={() => setShowModal(false)}
                user={filters.user}
                userId={filters.userId}
                start={filters.start}
                end={filters.end}
            />

        </Grid>

    )

}

export default UsersDashboard